import { clsx } from "@/src/utils/clsx"

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={clsx(
                "relative overflow-hidden rounded bg-gray-200",
                "before:absolute before:inset-0 before:-translate-x-full",
                "before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r",
                "before:from-transparent before:via-white/60 before:to-transparent",
                className
            )}
            {...props}
        />
    )
}
